import { Subscription } from '../models';
import { SubscriptionRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetSubscriptionUseCase {
  constructor(private subscriptionRepository: SubscriptionRepository) {}

  async execute(userId: string): Promise<Subscription | null> {
    logger.debug('GetSubscription', 'Fetching subscription', { userId });

    const subscription = await this.subscriptionRepository.getSubscription(userId);

    logger.debug('GetSubscription', 'Result', {
      plan: subscription?.plan ?? 'free (no record)',
    });

    return subscription;
  }
}
